// Your parent component file (e.g., CompanyCreateStep1Comp.js)

import React, { useState } from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { CompanyCreateField } from './Fields';
import { Button } from '../../../../components/Buttons';
import { selectConfig, selectWorks } from '../../../Api/selectors';
import {
  CREATE_REQUIRED_FIELDS_TYPE_COMPANY,
  CREATE_REQUIRED_FIELDS_TYPE_INDIVIDUAL,
  REQUEST_COMPANY,
} from '../../constants';
import { createCompany, setNewCompanyValue } from '../../actions';
import { selectCountries, selectNewCompany } from '../../selectors';
import { Loader } from '../../../../components/Loader';
import { CompanyStructureSelection } from '../../components/CompanyStructureSelection';
import { WorkflowsSectionDetails } from './WorkflowsSection';
import { isWithInstallation } from '../../../Vehicles/helpers';
import { WIENTJES_INSTALATION } from '../../../../containers/App/constants';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import { Modal, ModalControls } from '../../../../components/Modal';
import { CancelNotificationModal } from '../../components/OnCancelNotificationModal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import cn from 'classnames';
import styles from './FirstStep.module.css';
import PlaceAutocomplete from '../../components/AddressForm';
import { compareAdresses } from '../../helpers';
import { parseAddressToCompanyValues } from '../../parse-address';

const Container = styled.div`
  width: 100%;
  .cols {
  }
  .col {
    padding-right: 48px;
    @media (max-width: 768px) {
      width: 100%;
      min-width: 250px;
    }
  }

  h4 {
    margin-bottom: 18px;
  }

  .google-accept {
    max-width: 600px;
  }
  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin-right: 6px;
    }
    .col {
      @media (max-width: 768px) {
        width: 100%;
        min-width: 200px;
      }
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
`;

const STATE = {
  isCancelWithoutSave: null,
};

class CompanyCreateStep1Comp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
    this.state = {
      ...STATE,
      formData: {}, // Add state to hold form data
    };
  }

  handleFormDataUpdate = newFormData => {
    if (!this.props.company_id) {
      const dto = parseAddressToCompanyValues(newFormData, this.props.countries);
      Object.keys(dto).forEach(key => {
        this.props.setValue(dto[key], key);
      });
      this.setState({ formData: newFormData });
      return;
    }
    // this.props.setValue(newFormData?.name, 'name');
    this.setState({ formData: newFormData });
  };

  get company() {
    return this.props.company;
  }

  get requiredFields() {
    if (env.clientId !== AppClientId.AUTOWIENTJES) return [];
    const types =
      this.props.values.company_type === 'company'
        ? CREATE_REQUIRED_FIELDS_TYPE_COMPANY
        : CREATE_REQUIRED_FIELDS_TYPE_INDIVIDUAL;

    return types.filter(type => !this.props.values[type]);
  }

  get firstColTypes() {
    let types =
      this.props.values.company_type === 'company'
        ? ['company_type', 'name', 'kvk_number']
        : ['company_type', 'name', 'surname'];

    return types;
  }

  get thirdRowArr() {
    let types =
      this.props.values.company_type === 'company'
        ? ['company_email', 'phone_number', 'language']
        : ['phone_number', 'language', 'email'];

    if (this.props.values.company_type === 'company') {
      types.unshift('website');
    } else if (this.props.values.company_type === 'individual') {
      types.splice(2, 0, 'website');
    }

    return types;
  }

  get isShowCancelBtn() {
    return env.clientId === AppClientId.AUTOWIENTJES;
  }

  get backUrl() {
    let url = this.props.company_id ? `/companies/${this.props.company_id}` : '/companies';
    return url;
  }

  get homeAddressValues() {
    const address = {
      name: this.props.values?.name,
      addressLine1: this.props.values?.addressLine1,
      postcode: this.props.values?.postcode,
      city: this.props.values?.city,
      countryId: this.props.values?.countryId,
      website: this.props.values?.website,
      phone_number: this.props.values?.phone_number,
      lat: this.props.values?.lat,
      lng: this.props.values?.lng,
    };
    return address;
  }

  get formDataParsedAddress() {
    return parseAddressToCompanyValues(this.state.formData, this.props.countries);
  }

  create() {
    this.props.create(this.properties, this.options, result => {
      this.to(`/vehicles/${result.id}`);
    });
  }

  save() {
    this.props.onSave();
  }

  onApprove(answer, callback = () => {}) {
    return this.setState({ isCancelWithoutSave: answer }, () => callback());
  }

  cancel() {
    if (!this.state.isCancelWithoutSave) {
      return this.setState({ isShowCancelNotification: true });
    }
    if (this.state.isCancelWithoutSave == 'yes') {
      this.props.resetValues(this.props.values);
      return this.to(this.backUrl);
    }
    return this.setState({ isShowCancelNotification: false, isCancelWithoutSave: null });
  }

  acceptGoogleSuggestion(key) {
    const dto = this.formDataParsedAddress;

    if (dto?.[key]) {
      this.props.setValue(dto?.[key], key);
    }
    return;
  }

  acceptAllGoogleSuggestion() {
    const dto = this.formDataParsedAddress;
    Object.keys(dto).forEach(key => {
      this.props.setValue(dto[key], key);
    });
  }

  renderAcceptGoogleSuggestionBtn(type) {
    const isShowButton =
      this.formDataParsedAddress?.[type] &&
      this.props.company_id &&
      compareAdresses(this.homeAddressValues, this.formDataParsedAddress) &&
      this.props.values?.[type] !== this.formDataParsedAddress?.[type];
    if (!isShowButton) return;
    let label = this.formDataParsedAddress?.[type];
    if (type === 'countryId') {
      label = this.props.countries?.find(c => c?.id === this.formDataParsedAddress?.[type])?.name;
    }

    return (
      <HBox vCenter style={{ maxWidth: '400px' }}>
        {'Aanbevolen door Google: ' + label}
        <br />
        <ButtonComponent
          style="ButtonSoftEdit"
          size={'btn-sm'}
          onClick={() => {
            this.acceptGoogleSuggestion(type);
          }}
        >
          {this.lbl('accept')}
        </ButtonComponent>
      </HBox>
    );
  }

  render() {
    console.dir(this.company);
    if (this.props.work) return <Loader small />;

    return (
      <Container className={styles.container}>
        {/* {JSON.stringify(this.state.formData, null, 2)} */}
        {/* {this.state.formData.name} */}
        {this.state.isShowCancelNotification && (
          <CancelNotificationModal
            onYes={() => this.onApprove('yes', this.cancel.bind(this))}
            onNo={() => this.onApprove('no', this.cancel.bind(this))}
          />
        )}
        <HBox center className={styles?.google}>
          <div className={styles.searchContainer}>
            <PlaceAutocomplete onUpdate={this.handleFormDataUpdate} defaultValue={this.state.compareValue} />
          </div>
          {this.props.company_id && !this.formDataParsedAddress?.name && (
            <ButtonComponent
              style="ButtonSoftEdit"
              size={'btn-sm'}
              onClick={() => {
                this.setState({ compareValue: this.props.values?.name });
              }}
            >
              {this.lbl('google_places.compare_with_google_data')}
            </ButtonComponent>
          )}
          {this.formDataParsedAddress?.name &&
            this.props.company_id &&
            compareAdresses(this.homeAddressValues, this.formDataParsedAddress) && (
              <ButtonComponent
                style="ButtonSoftEdit"
                size={'btn-sm'}
                onClick={() => {
                  this.acceptAllGoogleSuggestion();
                }}
              >
                {this.lbl('google_places.accept_all')}
              </ButtonComponent>
            )}
        </HBox>

        <VBox className={cn('cols', styles.containerCol)}>
          <div className={cn('container-fluid info-card text-muted', styles.containerForm)}>
            <Wrapper className={styles.wrapper}>
              <div className={styles.containerFlex}>
                {this.firstColTypes.map(type => (
                  <div key={type}>
                    <CompanyCreateField
                      requiredFields={this.requiredFields}
                      company_id={this.props.company_id}
                      type={type}
                    />
                    {this.renderAcceptGoogleSuggestionBtn(type)}
                  </div>
                ))}

                {['addressLine1'].map(type => (
                  <div key={type}>
                    <CompanyCreateField
                      requiredFields={this.requiredFields}
                      company_id={this.props.company_id}
                      key={type}
                      type={type}
                    />
                    {this.renderAcceptGoogleSuggestionBtn(type)}
                  </div>
                ))}

                {['postcode', 'city', 'countryId'].map(type => (
                  <div>
                    <CompanyCreateField
                      requiredFields={this.requiredFields}
                      company_id={this.props.company_id}
                      key={type}
                      type={type}
                    />
                    {this.renderAcceptGoogleSuggestionBtn(type)}
                  </div>
                ))}

                {this.thirdRowArr.map(type => (
                  <div>
                    <CompanyCreateField
                      requiredFields={this.requiredFields}
                      company_id={this.props.company_id}
                      key={type}
                      type={type}
                    />
                    {this.renderAcceptGoogleSuggestionBtn(type)}
                  </div>
                ))}
              </div>

              <div className={styles.containerFlex}>
                {['accountManagerId'].map(type => (
                  <CompanyCreateField
                    requiredFields={this.requiredFields}
                    company_id={this.props.company_id}
                    key={type}
                    type={type}
                  />
                ))}
                {env.clientId === AppClientId.INDEWAL && (
                  <CompanyCreateField
                    requiredFields={this.requiredFields}
                    company_id={this.props.company_id}
                    key="parentCompany"
                    type="parentCompany"
                  />
                )}

                {env.clientId === AppClientId.INDEWAL && (
                  <CompanyCreateField
                    requiredFields={this.requiredFields}
                    company_id={this.props.company_id}
                    key="exact_sync_to_parent"
                    type="exact_sync_to_parent"
                  />
                )}
                {env.clientId === AppClientId.INDEWAL && (
                  <CompanyCreateField
                    requiredFields={this.requiredFields}
                    company_id={this.props.company_id}
                    key="vindat_legal_form"
                    type="vindat_legal_form"
                  />
                )}
                {env.clientId === AppClientId.INDEWAL && (
                  <CompanyCreateField
                    requiredFields={this.requiredFields}
                    company_id={this.props.company_id}
                    key="Vindat_Relation"
                    type="Vindat_Relation"
                  />
                )}
                {[
                  this.props.values.company_from_eu === 'NL' ? 'RDW_number' : ' ',
                  //'ORB_TDN_preference',
                  'status',
                ].map(type => (
                  <CompanyCreateField
                    requiredFields={this.requiredFields}
                    company_id={this.props.company_id}
                    key={type}
                    type={type}
                  />
                ))}
                <Wrapper>
                  <ButtonComponent
                    style={'ButtonSoftPrimary'}
                    onClick={() => this.to(`/companies/${this.props.company_id}/products`)}
                  >
                    {this.lbl('company.details.columns.products')}
                  </ButtonComponent>
                </Wrapper>

                {(env.clientId === AppClientId.HOOIKAMMER || env.clientId === AppClientId.HILTERMANN) && (
                  <WorkflowsSectionDetails company_id={this.props.company_id} editCompany />
                )}
              </div>

              <div className={styles.containerFlex}>
                {env.clientId === AppClientId.AUTOWIENTJES && (
                  <>
                    <CompanyCreateField company_id={this.props.company_id} key="owner_name" type="owner_name" />
                    <CompanyCreateField
                      company_id={this.props.company_id}
                      key="date_of_foundation"
                      type="date_of_foundation"
                    />
                    <CompanyCreateField company_id={this.props.company_id} key="type_ID" type="type_ID" />
                    <CompanyCreateField company_id={this.props.company_id} key="ID_number" type="ID_number" />
                    <CompanyCreateField company_id={this.props.company_id} key="expiration_date" type="expiration_date" />
                  </>
                )}

                {env.clientId === AppClientId.INDEWAL && (
                  <div>
                    <h4>{this.lbl(`company.property.title.transport_conditions`)}</h4>

                    {['wait_for_pickup'].map(type => (
                      <CompanyCreateField
                        requiredFields={this.requiredFields}
                        company_id={this.props.company_id}
                        key={type}
                        type={type}
                      />
                    ))}

                    {['no_release_before_incoming_transport'].map(type => (
                      <CompanyCreateField
                        requiredFields={this.requiredFields}
                        company_id={this.props.company_id}
                        key={type}
                        type={type}
                      />
                    ))}

                    {['no_incoming_payment_before_transport'].map(type => (
                      <CompanyCreateField
                        requiredFields={this.requiredFields}
                        company_id={this.props.company_id}
                        key={type}
                        type={type}
                      />
                    ))}
                    <h4>{this.lbl(`company.property.title.settings`)}</h4>

                    {['incoming_block', 'outgoing_block'].map(type => (
                      <CompanyCreateField
                        requiredFields={this.requiredFields}
                        company_id={this.props.company_id}
                        key={type}
                        type={type}
                      />
                    ))}
                    {['skip_KYC'].map(type => (
                      <CompanyCreateField
                        requiredFields={this.requiredFields}
                        company_id={this.props.company_id}
                        key={type}
                        type={type}
                      />
                    ))}
                  </div>
                )}
                {env.clientId == AppClientId.AUTOWIENTJES && (
                  <>
                    <h4>{this.lbl(`company.property.title.settings`)}</h4>
                    {['incoming_block', 'outgoing_block'].map(type => (
                      <CompanyCreateField
                        requiredFields={this.requiredFields}
                        company_id={this.props.company_id}
                        key={type}
                        type={type}
                      />
                    ))}
                    {['skip_KYC'].map(type => (
                      <CompanyCreateField
                        requiredFields={this.requiredFields}
                        company_id={this.props.company_id}
                        key={type}
                        type={type}
                      />
                    ))}
                  </>
                )}
              </div>
            </Wrapper>
            <div className="d-flex gap-2 justify-content-end mt-2">
              {this.isShowCancelBtn && (
                <ButtonComponent style="ButtonSoftDelete" onClick={() => this.cancel()}>
                  {this.lbl('cancel')}
                </ButtonComponent>
              )}

              <ButtonComponent style="ButtonSoftPrimary" className="btn" disabled>
                {this.lbl('previous')}
              </ButtonComponent>
              <ButtonComponent style="ButtonSoftEdit" disabled={this.requiredFields.length} onClick={this.save.bind(this)}>
                {this.lbl('save')}
              </ButtonComponent>
            </div>
          </div>
        </VBox>
      </Container>
    );
  }
}

CompanyCreateStep1Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_COMPANY]),
    values: selectNewCompany(),
    config: selectConfig(),
    countries: selectCountries(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewCompanyValue(name, value));
    },
    create(properties, options, callback) {
      dispatch(createCompany(properties, options, callback));
    },
    resetValues(values, name = null) {
      Object.keys(values)?.map(type => dispatch(setNewCompanyValue(type, '')));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyCreateStep1 = compose(withConnect, withRouter)(CompanyCreateStep1Comp);
